import(/* webpackMode: "eager" */ "/home/u435054029/domains/forumtechnicalsolution.com/hbuilds/source/forumtechsolutions/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u435054029/domains/forumtechnicalsolution.com/hbuilds/source/forumtechsolutions/src/components/AnnouncementBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u435054029/domains/forumtechnicalsolution.com/hbuilds/source/forumtechsolutions/src/components/Header.tsx");
